export default "__VITE_ASSET__C2SQSA9a__"